import PlusIcon from "components/Icons/PlusIcon"
import {
  AddFoodButton,
  FoodBottomInfo,
  FoodBrand,
  FoodImageBox,
  FoodInfoBox,
  FoodLeft,
  FoodName,
  FoodNameBox,
  FoodNutrient,
  StyledIngredient,
} from "./styled"
import Highlighter from "react-highlight-words"
import { getDisplayCalories, getDisplayPortion } from "utils"
import { useState } from "react"
import { useAddedFoodAnimation } from "features/food/hooks/animation"
import SmallFoodImage from "components/foodDetails/share/SmallFoodImage"
import { useFoodBrandMaxWidth } from "utils/hooks"
import { formatUnit } from "utils/formater"
import { IngredientOptionType } from "model/food/types"
import { isEdamaFood } from "model/food/utils/typeGuards/foodTypeGuards"

const ArrowRightIcon = () => {
  return (
    <svg
      style={{ marginLeft: "auto" }}
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.21043 11.84C5.94772 11.6113 5.92836 11.2221 6.16719 10.9707L8.98835 8L6.16719 5.02934C5.92836 4.77786 5.94772 4.38866 6.21043 4.16004C6.47314 3.93142 6.87971 3.94995 7.11854 4.20144L10.3328 7.58605C10.5557 7.82077 10.5557 8.17923 10.3328 8.41395L7.11854 11.7986C6.87971 12.05 6.47314 12.0686 6.21043 11.84Z"
        fill="#00263A"
        fillOpacity="0.32"
      />
    </svg>
  )
}

const AddedButton = () => {
  const style = useAddedFoodAnimation()

  return (
    <AddFoodButton style={{ cursor: "default" }}>
      <svg
        style={{ transform: `scale(${style.scale})`, opacity: style.opacity }}
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
      >
        <rect width="32" height="32" rx="16" fill="#0FBDD4" />
        <path
          d="M24 10L13 21L8 16"
          stroke="white"
          strokeWidth="3.42857"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </AddFoodButton>
  )
}

interface IIngredientProps {
  ingredient: IngredientOptionType
  keyword?: string
  onSelect?: (ingredient: IngredientOptionType) => void
  onAdd?: (ingredient: IngredientOptionType) => void
  hideAddBtn?: boolean
  style?: React.CSSProperties
  hasArrow?: boolean
  isManualNutrition?: boolean
}

const Ingredient = (props: IIngredientProps) => {
  const {
    ingredient,
    keyword,
    onSelect,
    onAdd,
    hideAddBtn,
    style = {},
    hasArrow,
    isManualNutrition = false,
  } = props
  const { name, calorie, unit, portion } = ingredient

  const isEdama = isEdamaFood(ingredient)
  const imageUrl = isEdama ? ingredient.imageUrl : undefined
  const foodBrand = isEdama ? ingredient.brand : undefined
  const [showAddedIcon, setShowAddedIcon] = useState(false)

  const handleAddFood = () => {
    setShowAddedIcon(true)

    onAdd?.(ingredient)

    setTimeout(() => {
      setShowAddedIcon(false)
    }, 1000)
  }

  const { brandMaxWidth, foodNutritionRef } = useFoodBrandMaxWidth({
    brand: foodBrand,
  })

  const isDisplayPluralUnit = true

  return (
    <StyledIngredient style={style}>
      <FoodLeft onClick={() => onSelect?.(ingredient)}>
        <FoodImageBox>
          <SmallFoodImage src={imageUrl} />
        </FoodImageBox>
        <FoodInfoBox>
          <FoodNameBox>
            <FoodName>
              {" "}
              {keyword ? (
                <Highlighter
                  highlightClassName="high-light-text"
                  searchWords={keyword.split(" ")}
                  autoEscape={true}
                  textToHighlight={name}
                />
              ) : (
                name
              )}
            </FoodName>
          </FoodNameBox>

          {isManualNutrition ? null : (
            <FoodBottomInfo>
              <FoodNutrient ref={foodNutritionRef}>
                {getDisplayCalories(calorie)} cal, {getDisplayPortion(portion)}{" "}
                {formatUnit(unit, isDisplayPluralUnit)}{" "}
              </FoodNutrient>

              {foodBrand && (
                <FoodBrand style={{ maxWidth: brandMaxWidth }}>
                  <p>{foodBrand}</p>
                </FoodBrand>
              )}
            </FoodBottomInfo>
          )}
        </FoodInfoBox>
      </FoodLeft>

      {hasArrow && <ArrowRightIcon />}

      {!hideAddBtn &&
        (showAddedIcon ? (
          <AddedButton />
        ) : (
          <AddFoodButton onClick={() => handleAddFood()}>
            <PlusIcon />
          </AddFoodButton>
        ))}
    </StyledIngredient>
  )
}

export default Ingredient
